import { render } from "./Loby.vue?vue&type=template&id=d1249ae2&scoped=true&ts=true"
import script from "./Loby.vue?vue&type=script&lang=ts"
export * from "./Loby.vue?vue&type=script&lang=ts"

import "./Loby.vue?vue&type=style&index=0&id=d1249ae2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1249ae2"]])

export default __exports__